(function () {
  'use strict';

  var path = String(window.location.pathname || '').replace(/\/+$/, '');
  var configs = {
    '/collections/hop-up-parts-for-traxxas-mini-xrt': {
      label: 'Mini XRT',
      match: function (card) {
        return /\bmini\s+xrt\b/i.test(cardText(card));
      }
    },
    '/collections/hop-up-parts-for-traxxas-mini-slash-4x4': {
      label: 'Mini Slash 4X4',
      match: function (card) {
        return /\bmini\s+slash\s+4x4\b/i.test(cardText(card));
      }
    }
  };
  var config = configs[path];
  if (!config) return;

  // V644: Mini XRT / Mini Slash use the same visible collection layout as all other
  // vehicle pages. This runtime is membership-only: it reconciles the current
  // Mini Maxx compatibility source without creating a Mini-specific presentation.
  var serverGrid = document.querySelector('[data-integy-v642-virtual-mini-server="true"]');
  if (serverGrid) serverGrid.setAttribute('data-integy-v642-reconcile-pending', 'true');

  function qsa(selector, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(selector));
  }

  function cardText(card) {
    var title = card && card.querySelector ? card.querySelector('.productitem--title') : null;
    var titleText = title ? title.textContent : '';
    var tags = card && card.getAttribute ? card.getAttribute('data-product-tags') || '' : '';
    return (titleText + ' ' + tags).replace(/\s+/g, ' ').trim();
  }

  function cardTitle(card) {
    var node = card.querySelector('.productitem--title');
    return (node ? node.textContent : '').replace(/\s+/g, ' ').trim();
  }

  function cardSku(card) {
    return String(card.getAttribute('data-product-sku') || card.getAttribute('data-sku') || '').trim();
  }

  function cardPrice(card) {
    var node = card.querySelector('[data-price], .productitem__price .money, .price .money');
    if (!node) return Number.POSITIVE_INFINITY;
    var raw = String(node.textContent || '').replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    var value = parseFloat(raw);
    return Number.isFinite(value) ? value : Number.POSITIVE_INFINITY;
  }

  function requestedStockMode() {
    try {
      var params = new URLSearchParams(window.location.search || '');
      var nativeAvailability = params.get('filter.v.availability') || '';
      var customAvailability = params.get('integy_stock') || '';
      if (nativeAvailability === '0' || customAvailability === 'out') return 'out';
      if (customAvailability === 'all') return 'all';
      return 'in';
    } catch (error) {
      return 'in';
    }
  }

  function stockMatches(card, mode) {
    if (mode === 'all') return true;
    var explicit = card.getAttribute('data-product-available');
    if (explicit !== 'true' && explicit !== 'false') return true;
    var available = explicit === 'true';
    return mode === 'out' ? !available : available;
  }

  function currentSort() {
    try {
      return new URLSearchParams(window.location.search || '').get('sort_by') || '';
    } catch (error) {
      return '';
    }
  }

  function stableSort(cards, sortBy) {
    cards = cards.map(function (card, index) { return { card: card, index: index }; });
    var direction = 1;
    var kind = '';
    if (sortBy === 'title-ascending') kind = 'title';
    else if (sortBy === 'title-descending') { kind = 'title'; direction = -1; }
    else if (sortBy === 'price-ascending') kind = 'price';
    else if (sortBy === 'price-descending') { kind = 'price'; direction = -1; }
    if (!kind) return cards.map(function (entry) { return entry.card; });

    cards.sort(function (a, b) {
      var result = 0;
      if (kind === 'title') {
        result = cardTitle(a.card).localeCompare(cardTitle(b.card), undefined, { numeric: true, sensitivity: 'base' });
        if (!result) result = cardSku(a.card).localeCompare(cardSku(b.card), undefined, { numeric: true, sensitivity: 'base' });
      } else {
        result = cardPrice(a.card) - cardPrice(b.card);
        if (!Number.isFinite(result) || result === 0) {
          result = cardTitle(a.card).localeCompare(cardTitle(b.card), undefined, { numeric: true, sensitivity: 'base' });
        }
      }
      return result ? result * direction : a.index - b.index;
    });
    return cards.map(function (entry) { return entry.card; });
  }

  function buildSourceUrl() {
    var current = new URLSearchParams(window.location.search || '');
    var params = new URLSearchParams();
    params.set('view', 'integy-mini-compat');
    var sortBy = current.get('sort_by');
    if (sortBy) params.set('sort_by', sortBy);

    var nativeAvailability = current.get('filter.v.availability');
    var customStock = current.get('integy_stock');
    if (customStock === 'all') {
      params.set('integy_stock', 'all');
    } else if (customStock === 'out' || nativeAvailability === '0') {
      params.set('filter.v.availability', '0');
    } else {
      params.set('filter.v.availability', '1');
    }
    return '/collections/hop-up-parts-for-traxxas-mini-maxx?' + params.toString();
  }

  function ensureGrid() {
    var grid = document.querySelector('[data-integy-v453-fallback-grid], [data-productgrid-items], .productgrid--items');
    if (grid) return grid;
    grid = document.createElement('div');
    grid.className = 'productgrid--items products-per-row-5';
    grid.setAttribute('data-html', 'productgrid-items');
    grid.setAttribute('data-productgrid-items', '');
    grid.setAttribute('data-integy-v453-fallback-grid', '');
    var noResults = document.querySelector('.productgrid--no-results');
    var pagination = document.querySelector('.pagination--container, .pagination');
    if (noResults && noResults.parentNode) noResults.parentNode.insertBefore(grid, noResults);
    else if (pagination && pagination.parentNode) pagination.parentNode.insertBefore(grid, pagination);
    else {
      var wrapper = document.querySelector('.productgrid--wrapper, .productgrid--outer, main');
      if (wrapper) wrapper.appendChild(grid);
    }
    return grid;
  }

  function updateCount(count) {
    var text = count + (count === 1 ? ' product' : ' products');
    qsa('[data-integy-collection-product-count]').forEach(function (node) {
      node.textContent = text;
      node.setAttribute('data-integy-v642-count', String(count));
    });
    var outer = document.querySelector('[data-integy-result-count]');
    if (outer) outer.setAttribute('data-integy-result-count', String(count));
  }

  function updateNoResults(count) {
    var noResults = document.querySelector('.productgrid--no-results');
    if (count > 0) {
      if (noResults) noResults.hidden = true;
      return;
    }
    if (!noResults) {
      noResults = document.createElement('div');
      noResults.className = 'productgrid--no-results';
      noResults.innerHTML = '<h2 class="productgrid--no-results-title">No products match this filter combination.</h2>' +
        '<a class="productgrid--no-results-button" href="' + path + '?integy_stock=all">View all items</a>';
      var grid = document.querySelector('[data-productgrid-items], .productgrid--items');
      if (grid && grid.parentNode) grid.parentNode.insertBefore(noResults, grid.nextSibling);
    }
    noResults.hidden = false;
  }

  function normalizeCardLinks(card) {
    qsa('[data-product-page-link]', card).forEach(function (link) {
      var href = String(link.getAttribute('href') || '');
      if (/^\/products\//.test(href)) link.setAttribute('href', path + href);
    });
  }

  function replaceGrid(cards) {
    var grid = ensureGrid();
    if (!grid) return;
    var fragment = document.createDocumentFragment();
    cards.forEach(function (card) {
      var cloned = document.importNode(card, true);
      normalizeCardLinks(cloned);
      fragment.appendChild(cloned);
    });
    while (grid.firstChild) grid.removeChild(grid.firstChild);
    grid.appendChild(fragment);
    grid.setAttribute('data-integy-v644-source-replaced', 'true');
    grid.setAttribute('data-integy-v642-count', String(cards.length));
    updateCount(cards.length);
    updateNoResults(cards.length);
    try {
      document.dispatchEvent(new CustomEvent('integy:v644:normalized-mini-ready', {
        detail: { collection: path, count: cards.length, stock: requestedStockMode(), sort: currentSort() }
      }));
    } catch (error) {}
  }

  var grid = ensureGrid();
  if (grid) grid.setAttribute('data-integy-v644-source-loading', 'true');

  fetch(buildSourceUrl(), { credentials: 'same-origin', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      return response.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cards = qsa('[data-integy-v641-mini-source] [data-product-item], [data-integy-v642-mini-source] [data-product-item]', doc)
        .filter(config.match)
        .filter(function (card) { return stockMatches(card, requestedStockMode()); });
      cards = stableSort(cards, currentSort());
      replaceGrid(cards);
    })
    .catch(function () {
      if (grid) grid.setAttribute('data-integy-v644-source-error', 'true');
    })
    .finally(function () {
      if (grid) grid.removeAttribute('data-integy-v644-source-loading');
      if (serverGrid) serverGrid.removeAttribute('data-integy-v642-reconcile-pending');
    });
})();
